<template>
  <svg
    class="empty-illustration"
    :class="`variant-${variant}`"
    viewBox="0 0 200 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="empty-bg-grad" x1="24" y1="16" x2="176" y2="144" gradientUnits="userSpaceOnUse">
        <stop stop-color="#faf5ff" />
        <stop offset="1" stop-color="#eef2ff" />
      </linearGradient>
      <linearGradient id="empty-accent-grad" x1="0" y1="0" x2="1" y2="1">
        <stop stop-color="#8b5cf6" />
        <stop offset="1" stop-color="#a78bfa" />
      </linearGradient>
      <linearGradient id="empty-card-grad" x1="0" y1="0" x2="0" y2="1">
        <stop stop-color="#ffffff" />
        <stop offset="1" stop-color="#f8fafc" />
      </linearGradient>
      <filter id="empty-soft-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="6" stdDeviation="8" flood-color="#7c3aed" flood-opacity="0.08" />
      </filter>
    </defs>

    <!-- 素材库：叠放图片卡片 + 上传角标 -->
    <template v-if="variant === 'materials'">
      <rect x="28" y="20" width="144" height="120" rx="22" fill="url(#empty-bg-grad)" stroke="#e9d5ff" stroke-width="1.2" />
      <g filter="url(#empty-soft-shadow)">
        <rect x="46" y="52" width="78" height="58" rx="12" fill="url(#empty-card-grad)" stroke="#e2e8f0" transform="rotate(-7 85 81)" />
        <rect x="76" y="58" width="78" height="58" rx="12" fill="#ffffff" stroke="#ddd6fe" stroke-width="1.4" />
        <circle cx="96" cy="78" r="5.5" fill="#fde68a" />
        <path d="M86 102L98.5 87.5L108 95L118.5 81L142 102Z" fill="#c4b5fd" />
        <path d="M86 102H142" stroke="#e9d5ff" stroke-width="1.2" stroke-linecap="round" />
      </g>
      <circle cx="152" cy="42" r="15" fill="url(#empty-accent-grad)" />
      <path d="M152 35.5V48.5M145.5 42H158.5" stroke="#ffffff" stroke-width="2.2" stroke-linecap="round" />
      <rect x="54" y="34" width="34" height="8" rx="4" fill="#ede9fe" />
      <rect x="54" y="34" width="20" height="8" rx="4" fill="#c4b5fd" />
    </template>

    <!-- 模版库：文档叠放 -->
    <template v-else-if="variant === 'templates'">
      <rect x="28" y="20" width="144" height="120" rx="22" fill="url(#empty-bg-grad)" stroke="#e9d5ff" stroke-width="1.2" />
      <g filter="url(#empty-soft-shadow)">
        <rect x="58" y="44" width="84" height="72" rx="10" fill="#ffffff" stroke="#e2e8f0" transform="rotate(6 100 80)" />
        <rect x="54" y="48" width="84" height="72" rx="10" fill="url(#empty-card-grad)" stroke="#ddd6fe" stroke-width="1.4" />
        <rect x="68" y="62" width="44" height="5" rx="2.5" fill="#e9d5ff" />
        <rect x="68" y="74" width="56" height="4" rx="2" fill="#f1f5f9" />
        <rect x="68" y="84" width="48" height="4" rx="2" fill="#f1f5f9" />
        <rect x="68" y="98" width="36" height="12" rx="6" fill="url(#empty-accent-grad)" opacity="0.85" />
      </g>
      <path d="M132 38L142 48L132 58" stroke="#a78bfa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </template>

    <!-- 色板 -->
    <template v-else-if="variant === 'palette'">
      <rect x="28" y="20" width="144" height="120" rx="22" fill="url(#empty-bg-grad)" stroke="#e9d5ff" stroke-width="1.2" />
      <g filter="url(#empty-soft-shadow)">
        <circle cx="78" cy="78" r="22" fill="#fef3c7" stroke="#ffffff" stroke-width="3" />
        <circle cx="108" cy="70" r="22" fill="#bfdbfe" stroke="#ffffff" stroke-width="3" />
        <circle cx="122" cy="96" r="22" fill="#ddd6fe" stroke="#ffffff" stroke-width="3" />
        <circle cx="92" cy="104" r="22" fill="#fbcfe8" stroke="#ffffff" stroke-width="3" />
      </g>
      <path d="M148 44C148 44 142 52 136 52C130 52 126 46 128 40C130 34 138 32 142 36" stroke="#8b5cf6" stroke-width="2" stroke-linecap="round" />
    </template>

    <!-- 搜索无结果 -->
    <template v-else-if="variant === 'search'">
      <rect x="28" y="20" width="144" height="120" rx="22" fill="url(#empty-bg-grad)" stroke="#e9d5ff" stroke-width="1.2" />
      <circle cx="96" cy="74" r="28" fill="#ffffff" stroke="#ddd6fe" stroke-width="1.5" filter="url(#empty-soft-shadow)" />
      <circle cx="96" cy="74" r="16" stroke="#c4b5fd" stroke-width="3" />
      <path d="M108 86L120 98" stroke="#8b5cf6" stroke-width="3" stroke-linecap="round" />
      <path d="M88 74H104M96 66V82" stroke="#cbd5e1" stroke-width="2.2" stroke-linecap="round" opacity="0.8" />
    </template>

    <!-- 默认：轻量数据空态 -->
    <template v-else>
      <rect x="28" y="20" width="144" height="120" rx="22" fill="url(#empty-bg-grad)" stroke="#e9d5ff" stroke-width="1.2" />
      <g filter="url(#empty-soft-shadow)">
        <rect x="62" y="48" width="76" height="64" rx="14" fill="#ffffff" stroke="#ddd6fe" stroke-width="1.4" />
        <rect x="74" y="64" width="52" height="5" rx="2.5" fill="#e9d5ff" />
        <rect x="74" y="76" width="40" height="4" rx="2" fill="#f1f5f9" />
        <rect x="74" y="86" width="44" height="4" rx="2" fill="#f1f5f9" />
        <rect x="74" y="96" width="28" height="8" rx="4" fill="url(#empty-accent-grad)" opacity="0.75" />
      </g>
      <circle cx="148" cy="42" r="6" fill="#c4b5fd" opacity="0.6" />
      <circle cx="52" cy="108" r="4" fill="#bfdbfe" opacity="0.7" />
    </template>
  </svg>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: val => ['default', 'materials', 'templates', 'palette', 'search'].includes(val),
  },
});
</script>

<style scoped>
.empty-illustration {
  display: block;
  width: 100%;
  height: auto;
}
</style>
